import React from 'react';
import GameImage from '../components/GameImage';

// This is just wrong ... not sure how we should access this data ...
// Should be coming from the App ... maybe revisit after redux?
import ActivityList from '../data/ActivityList'
import GameList from '../data/GameList'
import PlayerList from '../data/PlayerList' // ditto

// check out https://codesandbox.io/s/vVoQVk78 and Roster.js for route ideas ...

const ViewEvent = (props) => {
  console.log(JSON.stringify(props));
  const event = ActivityList.getActivityForPlayer(null)[props.match.params.id];
  const game = GameList[event.gameId];

  const list = event.scores.map((player) => {
    //const linkto = '/eventinfo/' + event.gameId;
    // <Link to={linkto}>Game Info</Link>

    const winner = player.isWinner ? 'Winner!' : '';
    return (
      <li key={player.playerId}>
        playerId: {player.playerId}, name: {PlayerList[player.playerId].name}, score: {player.score}    {winner}
      </li>
    );
  });

  return (
    <div>
      <h1>View Game</h1>
      <p>{game.name}</p>
      <GameImage game={game} />
      <p>Players</p>
      <ul>
        {list}
      </ul>
    </div>
  );
};

export default ViewEvent;



// WEBPACK FOOTER //
// ./src/containers/ViewEvent.js